import axiosInstance from './axiosInstance'

export const getArtworkRequestById = (requestId) => {
  return axiosInstance.get(`/artwork-requests/${requestId}`)
}

export const getArtworkRequests = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc', status = 'Open', graphicDesignerId = 'All') => {
  return axiosInstance.get(`/artwork-requests?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}&status=${status}&graphicDesignerId=${graphicDesignerId}`)
}

export const createArtworkRequest = (data) => {
  return axiosInstance.post('/artwork-requests', data)
}

export const updateArtworkRequest = (requestId, data) => {
  return axiosInstance.put(`/artwork-requests/${requestId}`, data)
}

export const deleteArtworkRequest = (requestId) => {
  return axiosInstance.delete(`/artwork-requests/${requestId}`)
}
